import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppContext } from '../../app/Context';
import { i18nNS } from '../../i18n';
import { getIsSlideTitleSet } from '../../db/ppt';

const useHome = () => {
  const { t } = useTranslation([i18nNS.HOME, i18nNS.COMMON]);

  const { presentationId, activeSlideId, setSlideTitleAndSubtitle } = useAppContext();

  const setTitleAndSubTitle = useCallback(async () => {
    if (!presentationId) return;
    if (!activeSlideId) return;

    const isSlideTitleSet = await getIsSlideTitleSet(activeSlideId);

    if (isSlideTitleSet) return;

    setSlideTitleAndSubtitle({
      title: t('acadly_activity_plugin', { ns: i18nNS.COMMON }),
      subtitle: t('activity_was_not_added', { ns: i18nNS.HOME }),
    });
  }, [t, presentationId, activeSlideId, setSlideTitleAndSubtitle]);

  useEffect(() => {
    setTitleAndSubTitle();
  }, [setTitleAndSubTitle]);
};
export default useHome;
